import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plane, Languages, MapPin, Heart, Activity, Hotel, Video } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import InquiryForm, { InquiryFloatingBubble } from '../components/InquiryForm';
import { LandingFooter } from './landing/LandingFooter';
import { LandingCta } from './landing/LandingCta';
import { LandingPartners } from './landing/LandingPartners';
import { LandingWellness } from './landing/LandingWellness';
import { LandingSpecializations } from './landing/LandingSpecializations';
import { LandingHowItWorks } from './landing/LandingHowItWorks';
import { LandingFeatures } from './landing/LandingFeatures';
import { LandingHero } from './landing/LandingHero';
import { LandingHeader } from './landing/LandingHeader';
export default function Landing() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('patient');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showInquiryForm, setShowInquiryForm] = useState(false);

  const services = [
    { name: t('servicesMenu.airportPickup'), path: '/services/airport-pickup', icon: Plane },
    { name: t('servicesMenu.languageInterpreter'), path: '/services/language-interpreter', icon: Languages },
    { name: t('servicesMenu.surroundingTours'), path: '/services/surrounding-tours', icon: MapPin },
    { name: t('servicesMenu.nursingCare'), path: '/services/nursing-care', icon: Heart },
    { name: t('servicesMenu.physiotherapist'), path: '/services/physiotherapist', icon: Activity },
    { name: t('servicesMenu.travelAccommodation'), path: '/services/travel-accommodation', icon: Hotel },
    { name: t('servicesMenu.videoConsultations'), path: '/services/video-consultations', icon: Video },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Floating Inquiry Bubble */}
      <InquiryFloatingBubble />
      
      {/* Inquiry Form Modal */}
      <InquiryForm 
        isOpen={showInquiryForm} 
        onClose={() => setShowInquiryForm(false)} 
        triggerSource="hero_button"
      />
      
      {/* Header */}
      <LandingHeader mobileMenuOpen={mobileMenuOpen} navigate={navigate} services={services} setMobileMenuOpen={setMobileMenuOpen} t={t} />

      {/* Hero Section */}
      <LandingHero navigate={navigate} setShowInquiryForm={setShowInquiryForm} t={t} />

      {/* Features Section */}
      <LandingFeatures t={t} />

      {/* How It Works */}
      <LandingHowItWorks navigate={navigate} t={t} />

      {/* Specializations */}
      <LandingSpecializations navigate={navigate} t={t} />

      {/* Wellness & Yoga Preview Section */}
      <LandingWellness navigate={navigate} />

      {/* For Partners Section (Compact) */}
      <LandingPartners navigate={navigate} />

      {/* CTA Section */}
      <LandingCta navigate={navigate} setShowInquiryForm={setShowInquiryForm} t={t} />

      {/* Footer */}
      <LandingFooter t={t} />
    </div>
  );
}
